import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Drawer, message } from 'antd';
import PropTypes from 'prop-types';
import Axios from 'axios';

import OnTraccrCheckbox from '../../common/inputs/OnTraccrCheckbox';
import DrawerSubmitFooter from '../../common/containers/DrawerSubmitFooter';
import FormSelector from '../FormWorkflows/selectors/FormSelector';
import UserAssignmentSelector from '../FormWorkflows/selectors/UserAssignmentSelector';

export default function AssignedFormDrawer({
  visible,
  onClose,
}) {
  const [loading, setLoading] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [sharedForm, setSharedForm] = useState(false);

  const canSubmit = useMemo(() => (
    selectedForm && selectedUsers.length
  ), [selectedForm, selectedUsers]);

  const onAssignForm = useCallback(async () => {
    if (!canSubmit) return;
    setLoading(true);

    const payload = {
      form: selectedForm,
      users: selectedUsers,
      sharedForm,
      isManuallyAssigned: true,
    };

    try {
      await Axios.post('/forms/fieldTrigger/', payload);
      message.success('Form has been assigned');
    } catch (err) {
      message.error('Failed to assign form');
    }

    setLoading(false);
    onClose();
  }, [canSubmit, selectedForm, selectedUsers, sharedForm, onClose]);

  useEffect(() => {
    if (!visible) {
      setLoading(false);
      setSelectedForm(null);
      setSelectedUsers([]);
      setSharedForm(false);
    }
  }, [visible]);

  return (
    <Drawer
      title="Assign Form"
      visible={visible}
      width={600}
      bodyStyle={{ padding: '24px 24px' }}
      onClose={onClose}
    >
      <OnTraccrCheckbox
        onChange={(checked) => setSharedForm(checked)}
        defaultChecked={false}
        value={sharedForm}
        label="Shared Form?"
        hoverNode={(
          <div style={{ width: 300 }}>
            Check this box if you want to create one form and assign it to multiple people
            <br />
            <br />
            Leave this box unchecked if you want to create a separate form for each person.
          </div>
        )}
        style={{ marginBottom: 10 }}
      />
      <FormSelector
        hideExternalForms
        onChange={(newForm) => setSelectedForm(newForm)}
        selected={selectedForm}
      />
      <UserAssignmentSelector
        type="user"
        showPositions
        onChange={(newUsers) => setSelectedUsers(newUsers)}
        selected={selectedUsers}
      />
      <DrawerSubmitFooter
        canSubmit={canSubmit}
        loading={loading}
        onClose={onClose}
        onSubmit={onAssignForm}
      />
    </Drawer>
  );
}

AssignedFormDrawer.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
